import {
  SummaryData,
  Integration,
  RevenueNormalized,
  Indicator,
  Rating,
} from 'data/types/summary';
import formatPriceNumber from 'utils/formatPrice';

export const normalizeRating = (data: Rating) => ({
  name: data.name,
  value: data.rating,
});

export const normalizeIntegration = (data: Integration) => ({
  name: data.name,
  totalSales: parseInt(data.totalSales, 10),
});

export const normalizeRevenue = (data: Record<string, string | number>) => {
  const revenue: RevenueNormalized = Object.keys(data).map((key: string) => {
    return { xAxis: key, yAxis: parseInt(data[key] as string, 10) };
  });

  return revenue;
};

export const normalizeIndicator = (data: Indicator) => ({
  value: data.value,
  change: data.change,
});

export const normalizeSummary = (data: SummaryData) => ({
  updateAt: data.updateAt,
  totalSales: {
    value: formatPriceNumber(data.totalSales.value),
    change: data.totalSales.change,
  },
  orders: {
    value: data.orders.value,
    change: data.orders.change,
  },
  ordersPerDay: {
    value: data.ordersPerDay.value,
    change: data.ordersPerDay.change,
  },
  aov: {
    value: formatPriceNumber(data.aov.value),
    change: data.aov.change,
  },
  revenue: normalizeRevenue(data.revenue),
  topItems: data.topItems.map(([name, count]) => ({ name, count })),
  ratings: data.ratings.map(normalizeRating),
  sales: data.integrationRatings.map(normalizeIntegration),
});

export type Summary = ReturnType<typeof normalizeSummary>;
